import {
  HHLink,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';
import { Theme } from '@mui/material';

interface BillingMenuLinkProps {
  name: string;
  link: string;
  Icon: React.ElementType;
  onClick: () => void;
  dataTestId?: string;
}

export const BillingMenuLink = ({
  name,
  link,
  Icon,
  onClick,
  dataTestId,
}: BillingMenuLinkProps): JSX.Element => (
  <HHLink
    href={link}
    style={{ textDecoration: 'none', width: '100%' }}
    onClick={onClick}
    data-testid={dataTestId}
  >
    <HHStack
      alignItems="center"
      direction="row"
      gap={2}
      padding={2}
      sx={{
        width: '100%',
        transition: 'background-color 0.2s',
        '&:hover': {
          backgroundColor: 'action.hover',
        },
      }}
    >
      <Icon
        color="primary"
        aria-label={name}
        sx={{
          fontSize: 24,
          color: (theme: Theme) => theme.palette.primary.dark,
        }}
      />
      <HHTypography
        hhVariant="body"
        color={(theme: Theme): string => theme.palette.primary.dark}
      >
        {name}
      </HHTypography>
    </HHStack>
  </HHLink>
);

export default BillingMenuLink;
